module.exports = __webpack_public_path__ + "img/youtube.91559bd9.png";